import fetchWithOptions from '../../../shared/utils/fetch';
import { Organization } from '../types/auth';
import { Coworker, ServerCoworker } from '../types/coworkers.type';

export const getCoworkers = async (
  organizationId: Organization['id'],
): Promise<Coworker[] | null> => {
  try {
    const coworkers = await fetchWithOptions<ServerCoworker[]>(
      `/api/organization/${organizationId}/membership`,
    );

    return coworkers.map(jsonToCoworker);
  } catch {
    return null;
  }
};

const jsonToCoworker = ({ id, name }: ServerCoworker): Coworker => ({
  id,
  name,
});
